module.exports = __webpack_public_path__ + "static/media/12.b2b221c5.png";